import { List } from 'components';

const LanguagesEn: React.FC = () => {
  return (
    <List>
      <li>
        <b>English</b>
      </li>
      <li>
        <b>German</b>
      </li>
      <li>
        <b>Ukrainian</b>
      </li>
      <li>
        <b>Russian</b>
      </li>
    </List>
  );
};

export default LanguagesEn;
